module.exports = __webpack_public_path__ + "static/media/mobile-esh@2x.da40645d.png";